import React, { useEffect, useState } from 'react';
import { getAdminProfileByEmail, updateEmployee } from '../../../services/admin/api';
import PopupModel from '../../../components/popup-model/PopupModel';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './view-profile.css';

const ViewProfile = () => {
  const [profile, setProfile] = useState(null);
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(true);

  const [modalInfo, setModalInfo] = useState({
    show: false,
    title: '',
    message: '',
    isSuccess: true,
  });

  const showModal = (title, message, isSuccess) => {
    setModalInfo({ show: true, title, message, isSuccess });
  };

  const fetchProfile = () => {
    setLoading(true);
    const email = localStorage.getItem('user_email');
    if (email) {
      getAdminProfileByEmail(email)
        .then((data) => {
          setProfile(data);
          setPhone(data.phonenumber || '');
        })
        .catch(() => {
          showModal('Error', 'Failed to load profile.', false);
        })
        .finally(() => setLoading(false));
    } else {
      showModal('Error', 'User email not found in local storage.', false);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  // const closeModal = () => {
  //   if (modalInfo.isSuccess) {
  //     fetchProfile(); // Only refresh the profile data, not the whole page
  //   }
  //   setModalInfo((prev) => ({ ...prev, show: false }));
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!phone || phone.length !== 10) {
      // showModal('Validation Error', 'Please enter a valid 10-digit mobile number.', false);
        toast.error('Please enter a valid 10-digit mobile number.');

      return;
    }

    try {
      if (!profile || !profile.userid) {
        // showModal('Error', 'Profile ID is missing. Cannot update.', false);
        toast.error('Profile ID is missing. Cannot update.');
        return;
      }

      const payload = {
        ...profile,
        phonenumber: phone,
      };

      await updateEmployee(profile.userid, payload);
       toast.success("Profile Updated Successfully", {  autoClose: 3000,  });
      // showModal('Success', 'Mobile number updated successfully!', true);
    } catch (err) {
      const errorMessage =
        err?.response?.data?.message || err?.message || 'Something went wrong while updating.';

      if (
        errorMessage.includes('No values were changed') ||
        errorMessage.includes('IllegalArgumentException')
      ) {
        // showModal('Info', 'No changes detected. Please modify the number before updating.', false);
                toast.error('No changes detected. Please modify the number before updating.');

      } else {
        // showModal('Error', errorMessage, false);
                toast.error( errorMessage, false);

      }

   
    }
  };

  const handleCancel = () => {
    setPhone(profile.phonenumber || '');
    // showModal('Info', 'Changes discarded.', false);
    toast.error('Changes discarded.', false);

  };

  if (loading) return <div className="centered-message">
    <div className="spinner"></div>
    <div>Loading Profile Details ...</div>
  </div>;

  if (!profile) return <div className="admin-profile-status-message">No profile found.</div>;

  return (
    <div className="admin-add-employee-container">
      <div className="admin-add-employee-form-card">
        <form onSubmit={handleSubmit} className="admin-add-employee-form">
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="username">Username</label>
              <input type="text" id="username" value={profile.username || ''} readOnly disabled />
            </div>
            <div className="admin-form-group">
              <label htmlFor="companyName">Company Name</label>
              <input type="text" id="companyName" value={profile.companyname || ''} readOnly disabled />
            </div>
          </div>
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label htmlFor="email">Email</label>
              <input type="email" id="email" value={profile.email || ''} readOnly disabled />
            </div>
            <div className="admin-form-group">
              <label htmlFor="contactNumber">Contact Number</label>
              <input
                type="text"
                id="contactNumber"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                maxLength={10}
                pattern="\d*"
                placeholder="Enter 10-digit mobile number"
              />
            </div>
          </div>
          <div className="admin-form-actions">
            <button type="submit" className="admin-submit-button">Update</button>
              <button
                type="button"
                className="admin-cancel-button"
                onClick={handleCancel}
                disabled={phone === (profile.phonenumber || '')}
              >
                Cancel
              </button>
          </div>
        </form>
      </div>

      {/* Popup Modal */}
      {/* <PopupModel
        show={modalInfo.show}
        onClose={closeModal}
        title={modalInfo.title}
        message={modalInfo.message}
        isSuccess={modalInfo.isSuccess}
        className="admin-popup"
      /> */}
    </div>
  );
};

export default ViewProfile;
